import React from 'react';
import ReactDOM from 'react-dom/client';
import ForskningOgRapporter from './Components/ForskningOgRapporter/ForskningOgRapporter';
import setupHeaderAndFooter, {SearchSite} from './utils/setupHeaderAndFooter';
import 'udirsok-index.js'

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render( <ForskningOgRapporter/> );

setupHeaderAndFooter(SearchSite.FoR);
